import { NewspaperIcon } from "@heroicons/react/24/solid";

import { PERMISSIONS, ROUTE_PATHS } from "../../PermissionsConstants";
import DataConnection from "./DataConnection";
import AlarmType from "./AlarmType";
import DVRType from "./DVRType";
import CameraSystem from "./CameraSystem";
import FileCategory from "./FileCategory";
import WarrantyCoverage from "./WarrantyCoverage";
import SafeType from "./SafeType";
import CameraType1 from "./CameraType1";
import CameraType2 from "./CameraType2";
import SafeMake from "./SafeMake";

export const SecurityTabs = [
  {
    to: ROUTE_PATHS.Utilities_SecurityConfiguration_DataConnection_Index,
    path: "/utilities/SecurityConfiguration/DataConnection",
    icon: <NewspaperIcon className="h-4 w-4 float-left mr-2 " />,
    title: "Data Connection",
    component: DataConnection,
    permission:
      PERMISSIONS.permission_utilities_securityconfiguration_dataconnection_view,
  },
  {
    to: ROUTE_PATHS.Utilities_SecurityConfiguration_AlarmType_Index,
    path: "/utilities/SecurityConfiguration/AlarmType",
    icon: <NewspaperIcon className="h-4 w-4 float-left mr-2 " />,
    title: "Alarm Type",
    component: AlarmType,
    permission:
      PERMISSIONS.permission_utilities_securityconfiguration_alarmtype_view,
  },
  {
    to: ROUTE_PATHS.Utilities_SecurityConfiguration_DVRType_Index,
    path: "/utilities/SecurityConfiguration/DVRType",
    icon: <NewspaperIcon className="h-4 w-4 float-left mr-2 " />,
    title: "DVR Type",
    component: DVRType,
    permission:
      PERMISSIONS.permission_utilities_securityconfiguration_dvrtype_view,
  },

  {
    to: ROUTE_PATHS.Utilities_SecurityConfiguration_CameraSystem_Index,
    path: "/utilities/SecurityConfiguration/CameraSystem",
    icon: <NewspaperIcon className="h-4 w-4 float-left mr-2 " />,
    title: "Camera System",
    component: CameraSystem,
    permission:
      PERMISSIONS.permission_utilities_securityconfiguration_camerasystem_view,
  },
  {
    to: ROUTE_PATHS.Utilities_SecurityConfiguration_FileCategory_Index,
    path: "/utilities/SecurityConfiguration/FileCategory",
    icon: <NewspaperIcon className="h-4 w-4 float-left mr-2 " />,
    title: "File Category",
    component: FileCategory,
    permission:
      PERMISSIONS.permission_utilities_securityconfiguration_filecategory_view,
  },
  {
    to: ROUTE_PATHS.Utilities_SecurityConfiguration_WarrantyCoverage_Index,
    path: "/utilities/SecurityConfiguration/WarrantyCoverage",
    icon: <NewspaperIcon className="h-4 w-4 float-left mr-2 " />,
    title: "Warranty Coverage",
    component: WarrantyCoverage,
    permission:
      PERMISSIONS.permission_utilities_securityconfiguration_warrantycoverage_view,
  },
  {
    to: ROUTE_PATHS.Utilities_SecurityConfiguration_SafeType_Index,
    path: "/utilities/SecurityConfiguration/SafeType",
    icon: <NewspaperIcon className="h-4 w-4 float-left mr-2 " />,
    title: "Safe Type",
    component: SafeType,
    permission:
      PERMISSIONS.permission_utilities_securityconfiguration_safetype_view,
  },
  {
    to: ROUTE_PATHS.Utilities_SecurityConfiguration_CameraType1_Index,
    path: "/utilities/SecurityConfiguration/CameraType1",
    icon: <NewspaperIcon className="h-4 w-4 float-left mr-2 " />,
    title: "Camera Type 1",
    component: CameraType1,
    permission:
      PERMISSIONS.permission_utilities_securityconfiguration_cameratype1_view,
  },
  {
    to: ROUTE_PATHS.Utilities_SecurityConfiguration_CameraType2_Index,
    path: "/utilities/SecurityConfiguration/CameraType2",
    icon: <NewspaperIcon className="h-4 w-4 float-left mr-2 " />,
    title: "Camera Type 2",
    component: CameraType2,
    permission:
      PERMISSIONS.permission_utilities_securityconfiguration_cameratype2_view,
  },
  {
    to: ROUTE_PATHS.Utilities_SecurityConfiguration_SafeMake_Index,
    path: "/utilities/SecurityConfiguration/SafeMake",
    icon: <NewspaperIcon className="h-4 w-4 float-left mr-2 " />,
    title: "Safe Make",
    component: SafeMake,
    permission:
      PERMISSIONS.permission_utilities_securityconfiguration_safemake_view,
  },
];
